/**
 * Zeal Genesis - Daily Practice API Client
 */
import authFetch from './authFetch';
import { API_BASE } from './astrology';

export interface DailyTaskStatus {
  tasks: {
    login: boolean;
    tarot: boolean;
    moon: boolean;
    oracle: boolean;
    reflection: boolean;
    circle: boolean;
  };
  claimed: {
    login: boolean;
    tarot: boolean;
    moon: boolean;
    oracle: boolean;
    reflection: boolean;
    circle: boolean;
  };
  bonus_claimed: boolean;
  date: string;
}

export async function getDailyStatus(): Promise<{ daily_status: DailyTaskStatus; date: string }> {
  const res = await authFetch(`${API_BASE}/daily/status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Daily status API error: ${res.status}`);
  }

  return await res.json();
}

export async function claimDailyTask(taskId: string, date: string): Promise<{
  success: boolean;
  task_id: string;
  reward: number;
  soul_essence: number;
  tasks: Record<string, boolean>;
  claimed: Record<string, boolean>;
}> {
  const res = await authFetch(`${API_BASE}/daily/claim-task`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ task_id: taskId, date }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Claim task API error: ${res.status}`);
  }

  return await res.json();
}

export async function markDailyTask(taskName: string): Promise<void> {
  console.log(`[markDailyTask] Marking task: ${taskName}`);
  try {
    const response = await authFetch(`${API_BASE}/daily/mark-task`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ task_name: taskName }),
    });
    console.log(`[markDailyTask] Success: ${taskName}`, response.status);
  } catch (err) {
    console.error(`[markDailyTask] Error marking ${taskName}:`, err);
    // Don't block UI on error
  }
}

export async function claimDailyBonus(date: string): Promise<{
  success: boolean;
  reward: number;
  bonus_reward: number;
  task_reward: number;
  claimed_tasks: string[];
  soul_essence: number;
  bonus_claimed: boolean;
  tasks: Record<string, boolean>;
  claimed: Record<string, boolean>;
}> {
  const res = await authFetch(`${API_BASE}/daily/claim-bonus`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ date }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Claim bonus API error: ${res.status}`);
  }

  return await res.json();
}
